<template> 
    <div style="background:#fff;  "> 
        <div style=" line-height:30px;margin-top:2px;padding-top:2px;height:38px;display:flex;border-bottom:2px solid #389">    
 
            <el-select v-model="selparam3"  placeholder="请选择列名" clearable size="small" style="width:150px;margin-left:2px; ">
                <span v-for="item in dtlCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-input placeholder="请输入查询值"   v-model="textparam3" size="small" style="width:320px;height:30px;   ">
                 <el-select v-model="oper3" slot="prepend"  size="small" style="width:110px;  ">
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryStkData" style="color:#409eff"></el-button>
            </el-input> 
            <el-select v-model="selparam4"  placeholder="请选择列名" clearable size="small" style="width:150px;margin-left:5px; ">
                <span v-for="item in dtlCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            
            <el-input placeholder="请输入查询值"   v-model="textparam4" size="small" style="width:320px; height:30px;  ">
                <el-select slot="prepend" v-model="oper4"  size="small" style="width:110px; ">
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryStkData" style="color:#409eff"></el-button>
            </el-input>  
            <el-link @click="impCsv"  :underline="false" style="width:150px;">
                <i class="iconfont icon-xiazai" style="font-size:16px;  margin-left:25px;color:#409eff; "></i>
                <span style="font-size:12px;  font-weight:600;margin-left:5px;">导入库存调整csv</span>
            </el-link>
        </div>
        <el-table :data="dtlData" 
                border                            
                disabled-hover
                class="custom-table-border"
                style="overflow:auto;margin-top:3px;"
                v-loading="loading"
                element-loading-background = "rgba(255, 255, 255, .5)"
                element-loading-text = "加载中，请稍后..."
                element-loading-spinner = "el-icon-loading"
                size="small"
                ref="reftab"
                :height="tabHeight" 
                :max-height="tabHeight" 
                :row-key="getRowKey"
                highlight-current-row>
                <el-table-column
                type="index"
                label="序号"
                width="60">
                </el-table-column>
            <span  v-for="(item ,index) in dtlCol" :key="index">   
                <el-table-column   v-if="item.thide==='N'"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    sortable
                    :min-width="item.width">
                </el-table-column> 
            </span> 
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="80">
                <template slot-scope="scope">
                    <i class="iconfont icon-chazhao" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link :disabled="editBool" @click="dtlRec(scope.row )" :underline="false"  ><span style="font-size:10px;margin-right:5px;">查看</span></el-link>
                </template>
            </el-table-column>                       
        </el-table>    
 
        <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 导入csv-->
        <el-dialog :visible.sync="impWin" v-dialogDrag width="530px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">导入csv文件</span>
            </div> 
            <div style=" display:flex">
                <div style="width:120px;line-height:30px; ">请选择导入格式</div>
                <el-select  v-model="format"  style="width:380px"  placeholder="请选择">
                    <el-option   value="NEW" label="2023新表" ></el-option>
                    <!-- <el-option   value="OLD" label="2022旧表" ></el-option> -->
                </el-select> 
            </div>
            <div style=" display:flex;margin-top:15px;">
                <div style="width:120px;line-height:30px; ">请选择仓库</div>
                <el-select  v-model="stkid"  style="width:380px" filterable placeholder="请选择">
                    <el-option v-for="(it,index) in  stkArr " :key="index"  :value="it.CODE" :label="it.CNAME" ></el-option>
                </el-select> 
            </div>
            <div style="margin-top:15px;display:flex">
               <div style="width:120px;line-height:30px; "> 请选择月份</div>
               <el-date-picker type="month" size="midmum" style="width:380px" v-model="stkmth" clearable value-format="yyyy-MM" ></el-date-picker>
            </div>
              
            <div style=" display:flex">
                <Upload
                    ref="upload"
                    name="upfile"
                    :data="uploadData"
                    :show-upload-list="false"
                    :before-upload="beforeTxtFile"
                    :on-success="successTxtFile"
                    :on-progress="handleProgress"
                    :with-credentials="true"                       
                    :format="['csv' ]"
                    :max-size="4096"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :action="uploadUrl"
                    style="display: inline-block;width:90px;text-align:left ">                           
                        <el-link :underline="false" style="padding: 1px 0;width:120px;height:120px;">
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"  ></el-image> 
                        </el-link>                                                      
                </Upload>
                <div style="display:flex;flex-direction:column" >
                    <div style="line-height:55px;display:flex">
                        <div style="color:#483D8B;font-weight:600;font-size:12px;text-align:right;width:105px;margin-right:14px; ">文件路径</div>
                        <el-input size="small"  disabled v-model="txtPath" placeholder="显示项"  style="width:300px; " ></el-input>
                    </div>
                    <div style="line-height:55px;display:flex">
                        <div style="color:#483D8B;font-weight:600;font-size:12px;text-align:right;width:105px;margin-right:14px; ">文件名</div>
                        <el-input size="small"  disabled v-model="fileNm" placeholder="显示项"  style="width:300px; " ></el-input>
                    </div>
                    <div style="line-height:55px;display:flex">
                        <div style="color:#483D8B;font-weight:600;font-size:12px;text-align:right;width:105px;margin-right:14px; ">文档记录行数</div>
                        <el-input size="small"  disabled v-model="txtNum" placeholder="显示项"  style="width:300px; " ></el-input>
                    </div>
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:15px ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="impWin=false" style="margin-right:50px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="csvSure" style="margin-right:10px;">确定</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
 
        <!-- 盘点 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="chkWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">盘点记录详情 </span>
            </div> 
            <div style="height:89vh;overflow-y:auto">
            <Form ref="addForm" :model="chkCol" :label-width="120"    label-position="right" inline >
                <span v-for="(item,index) in dtlCol" :key="index" >
                    <FormItem :class="item.key=='MATDESC'?'item-width':'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                        <el-checkbox border v-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="chkCol[item.key]" style="width:100%"></el-checkbox> 
                        <el-input readonly  type="textarea" :rows="2"  v-else-if="item.key==='PRDNM'"   v-model="chkCol[item.key]"></el-input> 
                        <el-input :placeholder="item.holder" type="text" v-else disabled   v-model="chkCol[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>   
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="chkWin=false" style="margin-right:5px;">取消</el-button>
                </span>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getTabColOrData,getBaseData } from '../../api/user' 
import {getDate} from '../../api/Select' 
export default {
    name: 'amz_stockadjust',
    data () {
        return {
            format:'NEW',
            dataCount:0,
            rowSize:50,
            current:1,
            chkWin:false,
            chkCol:{},
            formCol:{},
            prompt:'', // 
            promptWin:false,
            input_hold:'请输入内容... 按回车键以查询',
            selparam:'ASIN',// select 绑定值
            oper:'like',
            textparam:'', // input 绑定值
            stkmth:'',
            dtlCol:[],
            tmpData:[] ,// 
            selparam2:'',// select 绑定值
            oper2:'like',
            textparam2:'',  
            selparam3:'ASIN',// select 绑定值
            oper3:'like',
            textparam3:'', 
            selparam4:'',// select 绑定值
            oper4:'like',
            textparam4:'', 
            dtlData:[],
            disabled:false,
            impWin:false,
            stkid:'',
            v_url:'xuper_auth/getTableRecMany' , //api请求路径      
            v_formurl:'xuper_auth/getTableRecMany', //多记录查询 like模式       
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            loading:false,// table加载bool
            type:'create',
            stkArr:[],
            operArr:[],
            treeid:'0',
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止 
            v_admin:this.$cookies.get('v_admin') ,//  
            txtPath:'',
            txtNum:'',
            fileNm:'',
            videoUploadPercent:0, 
            videoFlag:false,
            loadWin:false,
            uploadData:{} , 
            uploadUrl:'xuper_auth/readTxt' ,
            Accept: 'csv', //上传文件格式限制
            initWin:false,
            allData:[],
 
        }
    },
    created () {
        this.getTabCol() //得到 表列数组 
 
        this.getDtlData('')
    },
    components: {
 
    },
    mounted () {  
        getBaseData(this.v_url,'PARENTNO','22363','','','v_sys_base','').then(res=>{
            this.stkArr =res.result
        }) 
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });
 
         //用户表单新增、编辑、审核、作废权限 :frmid:94供应商资料ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','227471','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                console.log(JSON.stringify(row))
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        }) 
    } ,
    computed: {
        tabHeight() {
          return  window.innerHeight -190
        },
 
        dlgWidth: function() {
            return (window.innerWidth - 100) + 'px';
        }, 
    },
    methods: {  
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize;
            this.dtlData = this.allData.slice(_start,_end);
        },
        impCsv(){
            this.impWin =true
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择 csv'
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' 文件太大, 不能超出4M' 
        },
        // 文件上传成功时的钩子
        successTxtFile(res,file){
            this.videoUploadPercent=0  
            this.videoFlag=false   
            this.txtPath=res.result
            this.txtNum=res.rowcnt
            this.fileNm=file.name;            
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeTxtFile (res, file) {    
            this.fileName= this.v_username+getDate('year')
            this.uploadData = {
                p_code: this.fileName ,
                p_corpid:this.v_corpid,
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
        },
        //导入CSV
        csvSure(){
            if (!this.stkid){
                this.promptWin=true
                this.prompt ='请选择仓库'
            }else if (!this.stkmth){
                this.promptWin=true
                this.prompt ='请选择月份'
            } else{
                if (this.fileNm){
                    let v_url = this.format=='OLD'? 'xuper_auth/initStkCsv' :'xuper_auth/initStkCsv2'
                    
                    this.$confirm('你确定要导入此文件吗？','提示',{
                        confirmButtonText: '确定',
                        cancelButtonText:'取消',
                        customClass:'messageBox',
                        showClose:false,
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                        type:'info',
                    }).then(()=>{
                        this.loadWin=true
                        this.impWin =false
                        var vm=this
                        this.$axios({
                            method: 'post',
                            url: v_url +'',
                            data: {p_path:this.txtPath,corpid:this.v_corpid,code:this.stkid,p_user:this.v_username,p_key:this.stkmth},
                        }).then(res=>{        
                            if(res.code =='200')  {
                                this.loadWin =false
                                this.getDtlData('')   
                            }else{
                                this.promptWin=true
                                this.prompt =res.result
                            }     
                        }) 
                        
                    }).catch(()=>{})
                }else{
                    this.promptWin=true
                    this.prompt='文件名不能为空'
                }
                
            }
        },
        editRec(row){
            this.initWin =true
            this.formCol =JSON.parse(JSON.stringify(row))
        },
        dtlRec(row){
            this.chkWin =true
            this.chkCol =JSON.parse(JSON.stringify(row))
        },
        getRowKey(row){
            return row.IDSEQ
        },
  
        qryStkData(){
            let cond_=''
            if (this.selparam3 && this.textparam3){ //列1
                if (this.oper3==='like'){
                    cond_=cond_+' and '+this.selparam3+' like  \'%' + this.textparam3+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam3  +this.oper3+' \''+this.textparam3+'\' '
                }
            }
            if (this.selparam4 && this.textparam4){ //列1
                if (this.oper4==='like'){
                    cond_=cond_+' and  '+this.selparam4+'  like  \'%' + this.textparam4+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam4  +this.oper4+' \''+this.textparam4+'\' '
                }
            }
            this.getDtlData(cond_ )
        },
        //获取表单数据
        getDtlData(cond){
            var vm=this
            this.loading =true
            getTabColOrData(this.v_formurl,'v_STK_ADJUST','corpid',this.v_corpid,'','','','',cond).then((res) => {              
                if (res.code==='200'){
                    this.dtlData=res.result  
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                vm.loading =false         
            });            
        },
  
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227471','LSTSEQ','1' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                    })
                }
            })
        },
    }
}
 
</script>
<style scoped lang="less" >
    .selinput{
        width:340px;
        margin-left:10px; 
    }
    .colwidth{
        width:140px;
    }
    .colwidth2{
        width:642px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .item-width2  {
        width: 97%;
    } 
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table__body {
        width: 100%;
        // 使表格兼容safari，不错位
        table-layout: fixed !important;
    }
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
